import css from './Header.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

interface IProps {
  phone: string
  phonePrefix: string
  noMargin?: boolean
}

const OTPFormHeader: React.FC<IProps> = (props) => {
  const { phone, phonePrefix, noMargin } = props

  const { t } = useTranslation()
  
  return (
    <div className={css.auth_otpV2_header_container}>
      <div className={classNames(css.text_container, { [css.noMargin]: noMargin })}>
        <div className={css.insert_code_text}>{t('otpV2:insert_otp_code')}</div>

        <div className={css.number}>{`${phonePrefix} ${phone}`}</div>
      </div>
    </div>
  )
}

export default OTPFormHeader
